import { Helmet } from '@dr.pogodin/react-helmet';
import NoticeSiteHasBeenArchived from '../common/lib/NoticeSiteHasBeenArchived';
import PageNotFound from '../common/lib/PageNotFound';
import type { MultiLang } from '../config';
import Functions from '../functions';
import './assets/xwords.css';
import XwordsBreadcrumbs from './lib/XwordsBreadcrumbs';
import XwordsCategoryFieldset from './lib/XwordsCategoryFieldset';
import XwordsEntries from './lib/XwordsEntries';
import XwordsInitialFieldset from './lib/XwordsInitialFieldset';
import XwordsUtils from './lib/XwordsUtils';

interface Props {
    lang: MultiLang;
    catId: number;
    initial: string;
    start: number;
}

const XwordsLetter = (props: Props) => {
    const { lang, catId, initial, start } = props;
    const name = XwordsUtils.getName();
    const mtitle = Functions.mlang(name, lang);
    const ctitle = Functions.mlang(XwordsUtils.getCategoryName(catId), lang);
    const ititle = Functions.mlang(XwordsUtils.getInitialName(initial), lang);
    if (ctitle === '' || ititle === '') {
        return <PageNotFound lang={lang} />;
    }
    const title = Functions.mlang('[en]Initial[/en][ja]頭文字[/ja] : ', lang) + ititle;
    const baseUrl = XwordsUtils.getLetterUrl(initial, catId);
    const result = {
        total: XwordsUtils.getCountEntries(catId, initial),
        entries: XwordsUtils.getEntries(catId, initial, start),
    };
    return (
        <div className="xwords">
            <Helmet>
                <title>
                    {ititle} - {ctitle} - {mtitle} - {Functions.siteTitle(lang)}
                </title>
            </Helmet>
            <h3>{title}</h3>
            <NoticeSiteHasBeenArchived lang={lang} />
            <XwordsBreadcrumbs lang={lang} catId={catId} initial={initial} />
            <div className="row">
                <XwordsCategoryFieldset lang={lang} />
            </div>
            <div className="row">
                <XwordsInitialFieldset lang={lang} catId={catId} />
            </div>
            <h4 className="title">{Functions.mlang(XwordsUtils.getInitialName(initial), lang)}</h4>
            <XwordsEntries lang={lang} baseUrl={baseUrl} result={result} start={start} />
        </div>
    );
};

export default XwordsLetter;
